import { render, staticRenderFns } from "./NewAssets.vue?vue&type=template&id=c971e6ce&scoped=true&"
import script from "./NewAssets.vue?vue&type=script&lang=js&"
export * from "./NewAssets.vue?vue&type=script&lang=js&"
import style0 from "./NewAssets.vue?vue&type=style&index=0&id=c971e6ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c971e6ce",
  null
  
)

export default component.exports